import {Injectable} from '@angular/core';
import {AbstractSessionService} from './abstract-session.service';
import {CreateSessionDto, SessionDto, UpdateSessionDto} from "@shared/dto";

@Injectable({
  providedIn: 'root'
})
export class SessionService extends AbstractSessionService<SessionDto, CreateSessionDto, UpdateSessionDto> {
}
